import { MailFilled, PhoneFilled } from "@ant-design/icons";
import { Col, Flex, Grid, Row, Space } from "antd";
import { Typography } from "antd";
import { useStore } from "../../../context/CreateStoreContext";
import dayjs from "dayjs";

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

export default function Information() {
  const { selectedStore } = useStore();
  const screen = useBreakpoint();

  return (
    <div
      style={{
        padding: "30px",
        borderRadius: "16px",
        backgroundColor: "rgb(0 122 255 / 5%)",
        border: "1px solid #E5E5EA",
      }}
    >
      <Flex justify="space-between" style={{ marginBottom: "40px" }}>
        <Space direction="vertical" size="0">
          <Title
            style={{
              margin: 0,
              color: "#007AFF",
              fontWeight: "bolder",
              fontSize:
                screen.xs || screen.lg === false
                  ? "18px"
                  : screen.lg === true
                  ? "24px"
                  : "20px",
            }}
          >
            {selectedStore?.storeName}
          </Title>
          <Text type="secondary">
            {selectedStore?.owner?.legalBusinessName}
          </Text>
        </Space>

        <Space
          direction="vertical"
          size="0"
          style={{
            textAlign: "end",
          }}
        >
          <Text type="secondary" style={{ fontSize: "12px", lineHeight: 1 }}>
            Store Created
          </Text>
          <Text strong style={{ fontSize: "14px", lineHeight: 1 }}>
            {selectedStore?.createdAt
              ? dayjs(selectedStore?.createdAt).format("MMM D, YYYY")
              : null}
          </Text>
        </Space>
      </Flex>

      <Row gutter={[30, 30]}>
        <Col xs={24} md={12}>
          <Space direction="vertical" size="0">
            <Text type="secondary" style={{ fontSize: "12px" }}>
              Owner's Full Name
            </Text>
            <Text strong>{selectedStore?.owner?.name}</Text>
          </Space>
        </Col>
        <Col xs={24} md={12}>
          <Space direction="vertical" size="0">
            <Text type="secondary" style={{ fontSize: "12px" }}>
              Owner's Contact Info
            </Text>
            <Space size="small">
              <PhoneFilled rotate={90} style={{ color: "#A9AEB3" }} />
              <Text strong>{selectedStore?.owner?.phone}</Text>
            </Space>
            <Space size="small">
              <MailFilled style={{ color: "#A9AEB3" }} />
              <Text strong>{selectedStore?.owner?.email}</Text>
            </Space>
          </Space>
        </Col>
        <Col xs={24} md={12}>
          <Space direction="vertical" size="0">
            <Text type="secondary" style={{ fontSize: "12px" }}>
              Main Store Phone Number
            </Text>
            <Space size="small">
              <PhoneFilled rotate={90} style={{ color: "#A9AEB3" }} />
              <Text strong>{selectedStore?.phone}</Text>
            </Space>
          </Space>
        </Col>
        <Col xs={24} md={12}>
          <Space direction="vertical" size="0">
            <Text type="secondary" style={{ fontSize: "12px" }}>
              Store Address
            </Text>
            <Text strong>
              {selectedStore?.address?.street1}{" "}
              {selectedStore?.address?.street2},
            </Text>
            <Text strong>
              {selectedStore?.address?.city}, {selectedStore?.address?.state}{" "}
              {selectedStore?.address?.zipCode}, USA
            </Text>
          </Space>
        </Col>
        <Col md={12}>
          <Space direction="vertical" size="0">
            <Text type="secondary" style={{ fontSize: "12px" }}>
              Store Sales Tax %
            </Text>
            <Text strong>{selectedStore?.taxRate}%</Text>
          </Space>
        </Col>
      </Row>
    </div>
  );
}
